import { render, staticRenderFns } from "./UsersPasswordPolicyPage.vue?vue&type=template&id=5f254fb8&"
import script from "./UsersPasswordPolicyPage.vue?vue&type=script&lang=js&"
export * from "./UsersPasswordPolicyPage.vue?vue&type=script&lang=js&"
import style0 from "./UsersPasswordPolicyPage.vue?vue&type=style&index=0&id=5f254fb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports